import { render, staticRenderFns } from "./rfqUnreadMessage.vue?vue&type=template&id=8def49c8&scoped=true"
import script from "./rfqUnreadMessage.vue?vue&type=script&lang=js"
export * from "./rfqUnreadMessage.vue?vue&type=script&lang=js"
import style0 from "./rfqUnreadMessage.vue?vue&type=style&index=0&id=8def49c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8def49c8",
  null
  
)

export default component.exports